import React from "react"
import { useTranslation } from "react-i18next"

import { OverlayHeader } from "shared/ui/overlay/OverlayHeader"
import { OverlayWrapper } from "shared/ui/overlay/OverlayWrapper"

import { ProjectHistory } from "widgets/project-history/ProjectHistory"
import { ProjectHistoryModel } from "widgets/project-history/model/useProjectHistoryModel"
import {
  ProjectHistoryFilter,
  ProjectHistoryFilterState
} from "widgets/project-history/project-history-filter/ProjectHistoryFilter"

import "./styles/_project-history-overlay.scss"

export interface ProjectHistoryOverlayViewModel {
  historyModel: ProjectHistoryModel
  filterValues: ProjectHistoryFilterState
  onFilterChange: (state: ProjectHistoryFilterState) => void
  onClose: () => void
}

export const ProjectHistoryOverlayView = React.memo(
  ({
    historyModel,
    filterValues,
    onFilterChange,
    onClose
  }: ProjectHistoryOverlayViewModel) => {
    const { t } = useTranslation()

    return (
      <OverlayWrapper
        id="project-history-overlay"
        className="project-history-overlay"
        classNamePrefix="project-history-overlay"
        mobileFullscreen
      >
        <OverlayHeader.Container>
          <OverlayHeader.Title>
            {t("Project.Actions.History")}
          </OverlayHeader.Title>
          <OverlayHeader.CloseButton className="primary" onClick={onClose} />
        </OverlayHeader.Container>
        <div className="project-history-overlay__body">
          <ProjectHistoryFilter onChange={onFilterChange} />
          <ProjectHistory {...historyModel} filterValues={filterValues} />
        </div>
      </OverlayWrapper>
    )
  }
)
